import { jsx as _jsx } from "react/jsx-runtime";
///<reference types="@wcp/wcp-consent" />
import { useEffect } from 'react';
import { useThemeData } from '@msrceng/theme';
const placeholderId = 'cookie-consent-banner';
const initWcpConsent = ({ culture, isDarkMode, }) => {
    // Callback method when `wcp-consent` library has successfully initialized
    const initCallback = (err, _siteConsent) => {
        if (err) {
            console.error(err);
        }
        else {
            // TODO: do something here? https://msazure.visualstudio.com/One/_workitems/edit/13095565
            // console.log('#initCallback', { siteConsent });
        }
    };
    // Callback method when consent is changed by user
    const onConsentChanged = (_newConsent) => {
        // TODO: do something here? https://msazure.visualstudio.com/One/_workitems/edit/13095565
        // console.log('#onConsentChanged', { newConsent });
    };
    WcpConsent.init(culture, placeholderId, initCallback, onConsentChanged, 
    // @ts-ignore - This works. Not sure why TS is unhappy though.
    isDarkMode ? 'dark' : 'light');
};
/**
 * Implements the [WCP Cookie Consent JavaScript Library](https://eng.ms/docs/cloud-ai-platform/devdiv/one-engineering-system-1es/1es-docs/wcp/privacy/wcp-cookie-consent-api#cookie-consent-library---javascript),
 * the library used to "show consent banner, manage consents and record consent as required by the law."
 *
 * Since the banner displays based on IP address, you might not see it right now. Here are [some instructions on how to test if the banner is loading](https://eng.ms/docs/cloud-ai-platform/devdiv/one-engineering-system-1es/1es-docs/wcp/privacy/wcp-cookie-consent-api#how-to-test-if-banner-is-loading-for-eu-visitors).
 */
export const CookieConsentBanner = ({ culture = 'en-US', }) => {
    const { isDarkMode } = useThemeData();
    useEffect(() => {
        const script = document.createElement('script');
        script.async = true;
        script.onload = () => initWcpConsent({ culture, isDarkMode });
        script.src = 'https://wcpstatic.microsoft.com/mscc/lib/v2/wcp-consent.js';
        document.body.appendChild(script);
    }, [culture, isDarkMode]);
    return _jsx("div", { id: placeholderId });
};
